import {useMutation, type UseMutationOptions} from '@tanstack/react-query';
import {
	reorderAttributeVocabularyValues,
	type ReorderAttributeVocabularyValuesRequestOptions,
	type ReorderAttributeVocabularyValuesResult,
	type QueryError,
} from '../reorderAttributeVocabularyValues';

export * from '../reorderAttributeVocabularyValues';

export type UseReactQueryReorderAttributeVocabularyValuesOptions =
	UseMutationOptions<
		ReorderAttributeVocabularyValuesResult,
		QueryError,
		ReorderAttributeVocabularyValuesRequestOptions,
		ReorderAttributeVocabularyValuesResult
	>;

export const useReactQueryReorderAttributeVocabularyValues = (
	options: Omit<
		UseReactQueryReorderAttributeVocabularyValuesOptions,
		'mutationFn'
	> = {},
) =>
	useMutation<
		ReorderAttributeVocabularyValuesResult,
		QueryError,
		ReorderAttributeVocabularyValuesRequestOptions,
		ReorderAttributeVocabularyValuesResult
	>({
		mutationFn: reorderAttributeVocabularyValues,
		...options,
	});

export default useReactQueryReorderAttributeVocabularyValues;
